import { sdkRequest } from '@eventbrite/http';
import { deepKeysToCamel } from '@eventbrite/transformation-utils';
import { formatUrl } from 'url-lib';
import {
    FinancialInformationAPIResponse,
    FinancialInformationValues,
    TaxpayerInformationAPIResponse,
    TaxpayerInformationValues,
} from '../types';

export const fetchTaxpayerInformationSummary = (
    orgId: string,
): Promise<FinancialInformationValues | TaxpayerInformationValues> =>
    sdkRequest(
        formatUrl(`/api/v3/organizations/${orgId}/financial_information/`),
    )
        .then(
            (
                data:
                    | FinancialInformationAPIResponse
                    | TaxpayerInformationAPIResponse
                    | {},
            ) => deepKeysToCamel(data),
        )
        .catch(() => ({}));
